exports.itunes = 'http://www.itunes.com/dtds/podcast-1.0.dtd';
exports.content = 'http://purl.org/rss/1.0/modules/content/';